import React from 'react';
import { BarChartIcon, Button, InstallDesktopIcon, SettingsIcon } from 'tuui';
import { HelpTooltip, TOOLTIP_POSITION } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { IconsList } from '../IconsList';
import styles from '../../pages/thirdPartyConnect.module.scss';

export const IntroductionStep = ({ platformCode, platformName, onNext, onCancel }) => {
    const tooltipContent = (
        <div className={styles['tooltip-content']}>
            <p className={styles['tooltip-header']}>This app will:</p>
            <ul className={styles['tooltip-list']}>
                <li>Access your Realize Account ID</li>
                <li>Create Conversions in your account (when applicable)</li>
            </ul>
            <p className={styles['tooltip-footer']}>
                This access is granted only for setup and will be automatically revoked once the installation is
                complete.
            </p>
        </div>
    );

    return (
        <div>
            <IconsList platform={platformCode} />
            <h1 className={styles.title}>
                <FormattedMessage
                    id="3p-connect.intro.title"
                    defaultMessage={`Connect ${platformName} App to Realize`}
                    values={{ platformName }}
                />
            </h1>
            <div className={styles['permissions-section']}>
                <p className={styles['permissions-title']}>
                    <FormattedMessage
                        id="3p-connect.message.permissions.title"
                        defaultMessage="What permissions am I granting?"
                    />
                    <HelpTooltip
                        position={TOOLTIP_POSITION.BOTTOM}
                        content={tooltipContent}
                        iconClassName={styles['info-icon']}
                    />
                </p>
            </div>

            <FormattedMessage
                className={styles['features-heading']}
                id="3p-connect.features.heading"
                defaultMessage="You'll be able to:"
            />

            <div className={styles['features-list']}>
                <div className={styles['feature-item']}>
                    <div className={styles['feature-icon']}>
                        <InstallDesktopIcon />
                    </div>
                    <div className={styles['feature-content']}>
                        <h4 className={styles['feature-title']}>
                            <FormattedMessage
                                id="3p-connect.features.install.title"
                                defaultMessage="Install the Realize Pixel"
                            />
                        </h4>
                        <p className={styles['feature-description']}>
                            <FormattedMessage
                                id="3p-connect.features.install.description"
                                defaultMessage="Easily add the pixel to your website—no coding needed."
                            />
                        </p>
                    </div>
                </div>

                <div className={styles['feature-item']}>
                    <div className={styles['feature-icon']}>
                        <SettingsIcon />
                    </div>
                    <div className={styles['feature-content']}>
                        <h4 className={styles['feature-title']}>
                            <FormattedMessage
                                id="3p-connect.features.auto.title"
                                defaultMessage="Auto-create Conversions (when applicable)"
                            />
                        </h4>
                        <p className={styles['feature-description']}>
                            <FormattedMessage
                                id="3p-connect.features.auto.description"
                                defaultMessage="Set up tracking automatically for key events, saving time and reducing errors."
                            />
                        </p>
                    </div>
                </div>

                <div className={styles['feature-item']}>
                    <div className={styles['feature-icon']}>
                        <BarChartIcon />
                    </div>
                    <div className={styles['feature-content']}>
                        <h4 className={styles['feature-title']}>
                            <FormattedMessage
                                id="3p-connect.features.insights.title"
                                defaultMessage="Get campaign insights"
                            />
                        </h4>
                        <p className={styles['feature-description']}>
                            <FormattedMessage
                                id="3p-connect.features.insights.description"
                                defaultMessage="Track performance and optimize your campaigns with real-time conversion data."
                            />
                        </p>
                    </div>
                </div>
            </div>

            <div className={styles['buttons-container']}>
                <Button variant={Button.variant.ghost} className={styles['button']} onClick={onCancel}>
                    <FormattedMessage id="3p-connect.button.cancel" defaultMessage="Cancel" />
                </Button>
                <Button className={styles['button']} onClick={onNext}>
                    <FormattedMessage id="3p-connect.button.next" defaultMessage="Next" />
                </Button>
            </div>
        </div>
    );
};
